import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import SeoDashboard from "@/pages/SeoDashboard";

export const Route = createFileRoute("/seo")({
  head: () => buildHead({
    title: "Painel de SEO",
    description: "Painel interno de SEO, GEO e AEO da OP2P.",
    path: "/seo",
    noindex: true,
  }),
  component: SeoDashboard,
});
